
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from '@/components/ui/switch';

interface ContactFormData {
  name: string;
  position: string;
  email: string;
  phone: string;
  notes: string;
  isPrimary: boolean;
  status: string;
}

interface ContactFormProps {
  formData: ContactFormData;
  setFormData: React.Dispatch<React.SetStateAction<ContactFormData>>;
}

const ContactForm: React.FC<ContactFormProps> = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2.5">
        <Label htmlFor="name" className="text-sm font-semibold text-foreground">Name <span className="text-destructive">*</span></Label>
        <Input
          id="name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="John Doe"
        />
      </div>
      <div className="space-y-2.5">
        <Label htmlFor="position" className="text-sm font-semibold text-foreground">Position</Label>
        <Input
          id="position"
          value={formData.position}
          onChange={(e) => setFormData({ ...formData, position: e.target.value })}
          placeholder="CEO, Manager, etc."
        />
      </div>
      <div className="space-y-2.5">
        <Label htmlFor="email" className="text-sm font-semibold text-foreground">Email</Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          placeholder="john.doe@example.com"
        />
      </div>
      <div className="space-y-2.5">
        <Label htmlFor="phone" className="text-sm font-semibold text-foreground">Phone</Label>
        <Input
          id="phone"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          placeholder="+1 (555) 123-4567"
        />
      </div>
      <div className="space-y-2.5">
        <Label htmlFor="notes" className="text-sm font-semibold text-foreground">Notes</Label>
        <Textarea
          id="notes"
          value={formData.notes}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
          placeholder="Additional information about this contact..."
          className="resize-y min-h-[100px]"
        />
      </div>
      <div className="flex items-start space-x-3 p-4 rounded-lg bg-primary/5 border border-primary/20">
        <Switch
          id="isPrimary"
          checked={formData.isPrimary}
          onCheckedChange={(checked) => setFormData({ ...formData, isPrimary: checked })}
        />
        <div className="space-y-0.5">
          <Label htmlFor="isPrimary" className="text-sm font-semibold cursor-pointer">Primary Contact</Label>
          <p className="text-xs text-muted-foreground">Mark this as the main point of contact for this lead</p>
        </div>
      </div>
      <div className="flex items-start space-x-3 p-4 rounded-lg bg-destructive/5 border border-destructive/20">
        <Switch
          id="leftCompany"
          checked={formData.status === 'left'}
          onCheckedChange={(checked) => setFormData({ ...formData, status: checked ? 'left' : 'active' })}
        />
        <div className="space-y-0.5">
          <Label htmlFor="leftCompany" className="text-sm font-semibold cursor-pointer">Exclude</Label>
          <p className="text-xs text-muted-foreground">Exclude this contact from email campaigns. Use for people who have left the company, or anyone you don't want selected as the main or campaign contact. Kept on file for reference.</p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
export type { ContactFormData };
